var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m37.365 34.97c1.2-0.10016 2.2-1.2 2.1-2.4v-22.8c0.10016-1.2-0.90002-2.3-2.1-2.4h-29.4c-1.2 0.10001-2.2 1.2-2.1 2.4v22.8c-0.10001 1.2 0.9 2.3 2.1 2.4h12.6v2.4h-4.2v1.1h12.6v-1.1h-4.2v-2.4zm-30.5-25.2c-0.10001-0.6 0.4-1.1 1-1.2h29.5c0.6 0.10001 1.1 0.6 1 1.2v22.8c0 0.6-0.40002 1.1-1 1.2h-29.4c-0.6-0.10016-1.1-0.6-1.1-1.2z",
  fill: "#505050"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m36.265 27.77v-16.8h-27.3v16.8zm-10.7-11.1 1.1 3.4c0 0.10001 0 0.20001 0.10016 0.30002 0 0.19994 0.10016 0.3001 0.10016 0.49999 0 0.19994 0.10016 0.3001 0.10016 0.39999 0-0.09978 0-0.30009 0.10016-0.39999 0-0.19994 0.09978-0.30009 0.09978-0.49999 0-0.19994 0.10016-0.30002 0.10016-0.30002l1.1-3.4h1.2l-1.9 5.7h-1.3l-1.9-5.7zm-2.3 0h1.1l-2.1 5.7h-1.1zm-5.7 0h1.5l2 5.7h-1.3l-0.40002-1.4h-2.1l-0.4 1.4h-1.3z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m7.9652 33.77h29.4c0.6-0.10016 1-0.6 1-1.2v-22.8c0.10016-0.6-0.40002-1.1-1-1.2h-29.5c-0.6 0.10001-1.1 0.6-1 1.2v22.8c0 0.6 0.5 1.1 1.1 1.2zm14.7-1.2c-0.6 0-0.99999-0.50003-0.99999-1.2 0-0.70001 0.39999-1.2 0.99999-1.2s0.99999 0.49999 0.99999 1.2c0 0.69997-0.39999 1.2-0.99999 1.2zm-14.7-22.8h29.4v19.2h-29.4z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m18.665 18.67c0-0.10001-0.10016-0.20001-0.10016-0.29998 0-0.10001-0.10016-0.29998-0.10016-0.4 0-0.10001-0.10016-0.29998-0.10016-0.4 0 0.10001-0.10016 0.20001-0.10016 0.4 0 0.20001-0.10016 0.29998-0.10016 0.4 0 0.10001-0.09978 0.20001-0.09978 0.29998l-0.40002 1.3h1.5z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m17.265 20.97h2.1l0.40002 1.4h1.3l-2-5.7h-1.5l-2 5.7h1.3zm0.70001-2.3c0-0.10001 0-0.20001 0.10016-0.29998 0.09978-0.10001 0.09978-0.29998 0.09978-0.4 0-0.10001 0.10016-0.29998 0.10016-0.4 0 0.10001 0.10016 0.20001 0.10016 0.4 0 0.20001 0.10016 0.29998 0.10016 0.4 0 0.10001 0.10016 0.29998 0.10016 0.29998l0.39999 1.3h-1.5zm6.4-2h-1.1l-2.1 5.7h1.1z",
  fill: "#505050"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m27.665 22.37 1.9-5.7h-1.2l-1.1 3.4c0 0.10001 0 0.20001-0.10016 0.30002 0 0.19994-0.09978 0.3001-0.09978 0.49999 0 0.19994-0.10016 0.3001-0.10016 0.39999 0-0.09978 0-0.30009-0.10016-0.39999-0.10016-0.10016-0.10016-0.30009-0.10016-0.49999 0-0.19994-0.10016-0.30002-0.10016-0.30002l-1.1-3.4h-1.2l1.9 5.7z",
  fill: "#505050"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m37.365 28.97v-19.2h-29.4v19.2zm-28.4-18h27.3v16.8h-27.3z",
  fill: "#505050"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.665,
  cy: 31.37,
  rx: 1,
  ry: 1.2,
  fill: "#28b557"
});

function SvgAv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv);
export default __webpack_public_path__ + "static/media/av.9b533e1b3656636de8864445b48dd626.svg";
export { ForwardRef as ReactComponent };